<template>
  <div style="height: 100%; background: #F2F2F6">
         <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">{{$t("base.index")}}</el-breadcrumb-item>
          <el-breadcrumb-item>产品管理</el-breadcrumb-item>
          <el-breadcrumb-item>租期管理</el-breadcrumb-item>
        </el-breadcrumb>

  <el-row style="margin-top:10px">

       <el-col :span="23" style="text-align:right">
        <el-button size="small" type="primary" @click="searchTenancy()">{{$t("base.search")}}</el-button>
        <el-button  :title="$t('base.new')" style="background:linear-gradient(to bottom,rgb(90, 157, 171),#0093a8);color:#ffffff" size="small" icon="el-icon-plus" @click="showTenancy()"></el-button>
      </el-col>
  </el-row>
   <el-divider></el-divider>
        <el-table
          :data="tabledata"
          ref="table"
          stripe
          border
          style="margin:0 30px;width: calc(100% - 60px);border-radius: 0.625rem;font-size:12px"
           :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'line-height': '20px', padding: '8px', 'text-align': 'center' }"
        >
          <el-table-column
            type="index"
            label=""
            width="75"
          ></el-table-column>
          <el-table-column prop="title" label="租期">
          </el-table-column>
           <el-table-column prop="days" label="天数">
           </el-table-column>
          <el-table-column :label="$t('base.opt')" column-key="opt" width="300">
            <template  slot-scope="scope"   >
              <el-button
              v-if="user.isadmin||($store.state.permission.CreateVersion&&$store.state.permission.CreateVersion.show)"
                size="mini"
                type="text"
                @click="showTenancy(scope.row)"
                >{{$t("base.edit")}}</el-button
              >
               <el-divider v-if="user.isadmin||($store.state.permission.CreateVersion&&$store.state.permission.CreateVersion.show)"   direction="vertical"></el-divider>
              <el-button
              v-if="user.isadmin||($store.state.permission.CreateVersion&&$store.state.permission.CreateVersion.show)"
              size="mini"
                type="text"
                @click="handleDelete(scope.row)"
                >{{$t("base.del")}}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-dialog title="租期" :close-on-click-modal="false" :visible.sync="dialogFormVisible">
  <el-form
          :model="tenancy"
          :rules="rules"
          ref="customerForm"
          label-width="150px"
          label-position="right"
          size="mini"
        >
        <el-form-item label="名称" prop="title">
            <el-input v-model="tenancy.title" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="天数" prop="days">
              <el-input v-model="tenancy.days" maxlength="3" type="number" ></el-input>
          </el-form-item>
          
        </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button @click="dialogFormVisible = false">取 消</el-button>
    <el-button type="primary" @click="saveTenancy()">确 定</el-button>
  </div>
</el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'RoleList',
  data () {
    return {
      user: {},
      tenancy: {
      },
      tabledata: [],
      dialogFormVisible: false,
      rules: {
        title: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        days: [{ required: true, message: '请输入天数', trigger: 'blur' }]
      }
    }
  },
  mounted: function () {
    var self = this
    let user = window.localStorage.getItem('customer')
    if (user) {
      this.user = JSON.parse(user)
      self.searchTenancy()
    } else {
      this.$message({
        message: this.$t('base.noSession'),
        type: 'warning'
      })
      self.$router.push({ name: 'Login' })
    }
  },
  methods: {
    showTenancy (row) {
      if (row) {
        this.tenancy = Object.assign({}, row)
      } else {
        this.tenancy = {days:0}
      }
      this.dialogFormVisible = true
    },

    saveTenancy () {
      this.$refs.customerForm.validate((valid) => {
        if (valid) {
          let url = '/product/tenancy/add'
          if (this.tenancy.innerid) {
            url = '/product/tenancy/edit'
          } 
          Vue.axios
            .post(url, this.tenancy)
            .then((res) => {
              if (res.data.errcode === 0) {
                this.$message({
                  showClose: true,
                  message: this.$t('base.saveSuccess'),
                  type: 'success'
                })
                this.searchTenancy()
                this.dialogFormVisible = false
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.errmsg || this.$t('base.systemError'),
                  type: 'error'
                })
              }
            })
        } else {
          return false
        }
      })
    },

    searchTenancy () {
      var self = this
      Vue.axios
        .post('/product/tenancy/all', { })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.tabledata = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t('base.systemError'),
              type: 'error'
            })
          }
        })
    
    },
    handleDelete (row) {
      this.$confirm(
        '确认删除' + row.title + '？',
        this.$t('base.info'),
        {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          var self = this
          Vue.axios
            .post('/product/tenancy/del', {
              innerid: row.innerid
            })
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  type: 'success',
                  message: self.$t('base.delSuccess')
                })
                self.searchTenancy()
              } else {
                self.$message({
                  showClose: true,
                  message:
                    res.data.errmsg || this.$t('base.systemError'),
                  type: 'error'
                })
              }
            })
        })
        .catch(() => {})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/ProductParams/Tenancy.vue